export const TYPE_LOCATION_REQUEST = 'locationRequest';